// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"a91fcd1a","545":"c34d37d0","561":"7e3838ad","578":"0e32d58e","676":"d3168545","829":"f8853065"}[chunkId] + ".chunk.js";
};